import React from 'react';
export function ProblemSection() {
  return <section className="w-full bg-black py-16 px-4 pt-[0px] pb-[0px]" data-id="element-187">
      <div className="max-w-3xl mx-auto text-center" data-id="element-188">
        <h2 className="text-2xl sm:text-3xl font-bold text-white mb-10" data-id="element-189">
          🚨 SI ERES ENTRENADOR O PROFESOR DE BOXEO,
          <br data-id="element-190" />
          <span className="text-[#F97316]" data-id="element-191">ESTO TE VA A SONAR FAMILIAR:</span>
        </h2>

        <div className="space-y-4 text-left mb-12" data-id="element-192">
          {[{
          text: 'Llegas al gimnasio sin saber exactamente qué ejercicio vas a dar hoy',
          cost: 'Tiempo, energía y autoridad frente al grupo'
        }, {
          text: 'Tus alumnos nuevos no progresan porque no tienes una secuencia clara',
          cost: 'Los pierdes en los primeros 60 días'
        }, {
          text: 'El 70% abandona antes del año y no sabes cómo prevenirlo',
          cost: 'Ingresos inestables mes a mes'
        }, {
          text: 'Cuando falta equipo o el espacio es pequeño, cancelas y pierdes el ingreso',
          cost: 'Un Plan B que nunca llega'
        }, {
          text: 'No puedes justificar subir el precio porque no tienes un sistema visible',
          cost: 'Sigues cobrando lo mismo de hace 3 años'
        }, {
          text: 'Siempre las mismas correcciones improvisadas sin un método que te respalde',
          cost: 'Alumnos que no mejoran y se van'
        }, {
          text: 'Tienes alumnos de distintos niveles juntos y la clase se convierte en caos',
          cost: 'Ni los nuevos aprenden ni los avanzados progresan'
        }, {
          text: 'Fin de mes y no sabes exactamente cuánto vas a cobrar',
          cost: 'Ansiedad y dependencia del boca en boca'
        }].map((item, i) => <div key={i} className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-193">
              <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-194">❌</span>
              <div data-id="element-195">
                <p className="text-white text-lg font-medium" data-id="element-196">{item.text}</p>
                <p className="text-gray-400 text-sm mt-1" data-id="element-197">
                  <span className="text-[#F97316] font-semibold" data-id="element-198">
                    Lo que te cuesta:
                  </span>{' '}
                  {item.cost}
                </p>
              </div>
            </div>)}
        </div>

        <p className="text-[#F97316] text-2xl sm:text-3xl font-black mb-8" data-id="element-199">
          💣 ¿Cuántas clases más vas a improvisar?
        </p>

        <div className="h-px bg-gradient-to-r from-transparent via-[#F97316] to-transparent w-full" data-id="element-200" />
      </div>
    </section>;
}